import produce from "immer"

import {
    ADD_ROLE,
    REMOVE_ROLE,
    SAVING_USER,
    SAVING_USER_ABORTED,
    SEARCH_ABORTED,
    SEARCH_DONE,
    SEARCH_USERS,
    SEARCHING_USERS,
    SELECT_USER,
    SET_USER_PROPERTY,
    USER_SAVED,
} from "./action_types"

import { SEARCH_TERM_CHANGED_ACTION } from "flows/search/actions"
import { addUserRole, removeUserRole, setUserProperty, User } from "model/user"
import { SEARCH_TERM_CHANGED } from "../search/action_types"
import {
    ADD_ROLE_ACTION,
    REMOVE_ROLE_ACTION,
    SAVE_USER_ACTION,
    SAVING_USER_ABORTED_ACTION,
    SAVING_USER_ACTION,
    SEARCH_ABORTED_ACTION,
    SEARCH_ACTION,
    SEARCH_DONE_ACTION,
    SEARCHING_USERS_ACTION,
    SELECT_USER_ACTION,
    SET_USER_PROPERTY_ACTION,
    USER_SAVED_ACTION,
} from "./actions"

type State = {
    loading: boolean
    saving: boolean
    searching: boolean
    list: User[]
    result_count?: number
}

const defaultState: State = {
    loading: false,
    saving: false,
    searching: false,
    list: [],
    result_count: undefined,
}

const selectedUser = (list: User[]) => list.find(user => user.selected)

type ACTION =
    | ADD_ROLE_ACTION
    | REMOVE_ROLE_ACTION
    | SELECT_USER_ACTION
    | SEARCH_ACTION
    | SAVE_USER_ACTION
    | SET_USER_PROPERTY_ACTION
    | SEARCH_TERM_CHANGED_ACTION
    | SEARCHING_USERS_ACTION
    | SEARCH_ABORTED_ACTION
    | SEARCH_DONE_ACTION
    | SAVING_USER_ACTION
    | SAVING_USER_ABORTED_ACTION
    | USER_SAVED_ACTION

export default (state = defaultState, action: ACTION) =>
    produce(state, draft => {
        switch (action.type) {
            case SELECT_USER:
                draft.list.forEach(user => {
                    user.selected = user.id === action.user_id
                })

                break
            case ADD_ROLE:
                {
                    const user = selectedUser(draft.list)
                    if (user) {
                        addUserRole(user, action.claim_name, action.role_name, action.roles_per_service)
                    }
                }
                break
            case REMOVE_ROLE:
                {
                    const user = selectedUser(draft.list)
                    if (user) {
                        removeUserRole(user, action.claim_name, action.role_name, action.roles_per_service)
                    }
                }
                break
            case SEARCH_USERS:
                return defaultState
            case SEARCHING_USERS:
                draft.searching = true
                break
            case SEARCH_ABORTED:
                return defaultState
            case SEARCH_DONE:
                draft.searching = false
                draft.list = action.users
                draft.result_count = action.total
                break
            case SET_USER_PROPERTY:
                {
                    const user = selectedUser(draft.list)
                    if (!user) return

                    setUserProperty(user, action.propertyPath, action.value)
                }
                break
            case SAVING_USER:
                draft.saving = true
                break
            case SAVING_USER_ABORTED:
                draft.saving = false
                break
            case USER_SAVED:
                {
                    const index = draft.list.indexOf(
                        draft.list.filter(user => user.id === action.user.id)[0]
                    )
                    draft.list[index] = {
                        ...draft.list[index],
                        unsaved_changes: false,
                        ...action.user,
                    }
                    // Delete the patch object so that saved changes are not mixed with future changes.
                    delete draft.list[index].patch
                    draft.saving = false
                }
                break
            case SEARCH_TERM_CHANGED:
                draft.searching = true

                break
            default:
                return state
        }
    })
